module.exports = __webpack_public_path__ + "img/logo-ecopole.9a57f02e.png";